import React, {Component} from 'react'
import {Label, Input} from 'reactstrap'
import PropTypes from 'prop-types'
import {Query} from 'react-apollo'

import permissionsQuery from '../../../queries/server/permissions'
import PermissionCheckboxListItem from "./PermissionCheckboxListItem";
const collator = new Intl.Collator(undefined, {numeric: true, sensitivity: 'base'});

export default class PermissionsCheckboxList extends Component {

    state = {
        selectAllChecked: false
    }

    selectAll = (permissions, access) => {
        this.props.onSelectAll(permissions.map(p => ({...p, access})))
    }

    render() {

        const {selectedPermissions, onChange} = this.props
        const {selectAllChecked} = this.state

        console.log('selectedPermissions', selectedPermissions)

        return (
            <Query query={permissionsQuery}>
                {({data, loading, error}) => {

                    if (loading) return <p>Loading...</p>

                    return (
                        <div className="d-flex flex-column">
                            <Label check className="font-weight-bold">
                                <Input
                                    type="checkbox"
                                    checked={selectAllChecked}
                                    onClick={() => {
                                        this.setState({selectAllChecked: !selectAllChecked})
                                        this.selectAll(data.permissions, !selectAllChecked)
                                    }}
                                />{' '}
                                {selectAllChecked ? 'Deselect All' : 'Select All'}
                            </Label>
                            {data.permissions
                                .sort((a, b) => collator.compare(a.name, b.name))
                                .map(({permission_id, name}) => (
                                    <PermissionCheckboxListItem
                                        key={permission_id}
                                        permission_id={permission_id}
                                        name={name}
                                        checked={(selectedPermissions || []).some(p => p.permission_id === permission_id && p.access)}
                                        onChange={onChange}
                                    />
                                ))}
                        </div>
                    )

                }}
            </Query>
        )
    }

}

PermissionsCheckboxList.propTypes = {
    selectedPermissions: PropTypes.array,
    onChange: PropTypes.func,
    onSelectAll: PropTypes.func
}